import createReducer from './create-reducer';

const initial = {
  page: 1,
  perPageCard: 10,
  perPageTable: 20,
  layout: 'table-layout', //todo make this come form layout strategy ?
  search: '',
  facets: [],
  pagerInfo: {}
};

const reducers = {
  UPDATE_SEARCHABLEENTITIES_LAYOUT: (state, value) => {
    return {
      ...state,
      ...{
        pagerInfo: value.pagerInfo,
        layout: value.layout
      }
    };
  },
  UPDATE_SEARCHABLEENTITIES_PAGE: (state, value) => {
    return { ...state, ...{ page: value.page, pagerInfo: value.pagerInfo } };
  },
  UPDATE_SEARCHABLEENTITIES_PERPAGE: (state, value) => {
    return { ...state, ...{ perPage: value } };
  },
  UPDATE_SEARCHABLEENTITIES_SEARCH_TERM: (state, value) => {
    return { ...state, ...{ search: value } };
  },
  UPDATE_SEARCHABLEENTITIES_SEARCH_FACETS: (state, value) => {
    return { ...state, ...{ facets: value } };
  }
};

export default createReducer(initial, reducers);
